// @ts-strict-ignore
import { useRefetchReadDeeplinks } from '@/features/CustomFeedV2/hooks/useFetchReadDeeplinks';
import { useFetchQueryParams } from '@/hooks/useFetchQueryParams';
import { useGetSearchType } from '@/hooks/useGetSearchType';
import { openInNewTab } from '@/utils/openInNewTab';

import { useGetRedirectUrl } from './useGetRedirectUrl';

export const useOpenFullScreen = ({ result }) => {
  const { access_key, board_id, channel_id, category_tab, source, deeplink } =
    result;

  const { board_id: boardIdParam, channel_id: channelIdParam } =
    useFetchQueryParams();
  const searchType = useGetSearchType();

  const redirectUrl = useGetRedirectUrl();
  const refetchReadDeeplinks = useRefetchReadDeeplinks();
  const openFullScreen = () => {
    const searchParams = new URLSearchParams();

    if (access_key) {
      searchParams.set('access_key', access_key);
    }

    if (board_id || boardIdParam) {
      searchParams.set('board_id', board_id || boardIdParam);
    }
    if (channel_id || channelIdParam) {
      searchParams.set('channel_id', channel_id || channelIdParam);
    }

    if (category_tab) {
      searchParams.set('category_tab', category_tab);
    }

    if (searchType) {
      searchParams.set('search_type', searchType);
    }

    searchParams.set('redirect', redirectUrl);

    openInNewTab(`/preview/${source}/${deeplink}?${searchParams.toString()}`);

    //TODO need to handle this refetch properly
    setTimeout(() => {
      refetchReadDeeplinks();
    }, 10000);
  };

  return {
    openFullScreen,
  };
};
